import React, { useState, useEffect } from "react";
import admin from "../../../services/adminService";

const AwesomeFeatures = () => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    let features = admin.getFeatures();
    setFeatures(features);
  }, []);

  return (
    <div className="container-fluid" id="features">
      <section className="mb-1 pt-5">
        <div className="row align-items-center">
          <div className="col-12">
            <h2 className="text-center title my-4 font-weight-bold h1">
              Awesome features
            </h2>
          </div>

          <p className="text-center font-weight-bolder mb-5 w-responsive mx-auto">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugit,
            error amet numquam iure provident voluptate esse quasi, veritatis
            totam voluptas nostrum quisquam eum porro a pariatur veniam.
          </p>

          <div className="col-12 px-lg-4">
            <div className="row align-items-center">
              {features.map((feature, index) => (
                <div key={index} className="col-lg-4 col-md-12 text-center">
                  {feature.col.map((features, index) => {
                    return features.type === "image" ? (
                      <img
                        key={features + index}
                        src={features.src}
                        alt="Inspire Features"
                        className="z-depth-0 img-fluid hoverable"
                      />
                    ) : (
                      <div key={features + index} className="row mb-3">
                        <div className="col-2 px-0 text-center">
                          <i
                            className={features.icon + " orange-text fa-2x"}
                          ></i>
                        </div>
                        <div className="col-10 mb-2 px-0 pr-lg-3">
                          <h5 className="font-weight-bold title text-left">
                            {features.title}
                          </h5>
                          <p className="font-weight-bolder text-justify">
                            {features.description}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AwesomeFeatures;
